import PI from "../services/progenda_interface";
import Config from "./config";

const createSessionToken = (targetPath, type, quickAccess, useProgendaDomain = false) => (
    PI.post({
        url: PI.apiV3SessionTokensPath(),
        data: {target_path: targetPath, name: type, quick_access: quickAccess, use_progenda_domain: useProgendaDomain}
    }).then(({ data }) => (data.apiUserSessionToken))
);

export default createSessionToken;